// import React from 'react';
// import { 
//   Network, ShieldAlert, Award, FileSpreadsheet, 
//   ChevronLeft, Percent, ShieldCheck, FileCheck, 
//   HelpCircle, Copy 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function FranchiseServices() {
  
//   // Core Franchise and Licensing service modules
//   const franchiseOffers = [
//     {
//       title: "صياغة وثيقة الإفصاح وقيدها",
//       desc: "إعداد وصياغة وثيقة الإفصاح (Disclosure Document) الشاملة والمطابقة لاشتراطات وزارة التجارة بدقة متناهية، وإتمام إجراءات قيدها رسمياً.",
//       icon: <FileSpreadsheet className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "هيكلة وصياغة عقود الامتياز",
//       desc: "صياغة وتطوير اتفاقيات الامتياز التجاري (Franchise Agreements) التي تنظم نسب العوائد، النطاق الجغرافي، معايير الجودة، وحقوق التدريب والدعم الفني.",
//       icon: <FileCheck className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "حماية العلامة والأسرار التجارية",
//       desc: "تأمين وحوكمة الأصول الفكرية الممنوحة، وصياغة أدلة التشغيل القانونية واتفاقيات عدم الإفصاح لحماية الخلطات الوصفية والتقنيات الخاصة بالمانح.",
//       icon: <Copy className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "إدارة منازعات الفرانشايز",
//       desc: "التمثيل القضائي والتحكيمي في منازعات إنهاء الامتياز غير المشروع، دعاوى المطالبة بالتعويض عن الإخلال بوعود التدريب، وحالات تسريب الأسرار التجارية.",
//       icon: <ShieldAlert className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات الامتياز التجاري (الفرانشايز)"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">صناعة التوسع الآمن ومضاعفة الأثر التجاري</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات الامتياز التجاري (الفرانشايز)</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             سواء كنت مانحاً تسعى للتوسع وبناء شبكة فروع لعلامتك الناجحة، أو ممنوحاً ترغب في استثمار آمن مستند إلى علامة تجارية قائمة؛ نحن نوفر لك الصياغة والحماية القانونية المتكاملة المتوافقة مع نظام الامتياز السعودي.
//           </p>
//         </div>
//       </section>

//       {/* Analytical & Growth Framework */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               تحويل نموذج عملك الناجح إلى منظومة قابلة للتكرار القانوني
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               لا يقتصر منح الامتياز التجاري على توقيع عقد بسيط، بل يتطلب تأسيس بيئة امتثال تشريعية تمنع الممنوحين من تشويه سمعة العلامة، وتضمن التزامهم التام بالمعايير التشغيلية الموحدة للمنشأة.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               يعمل مستشارونا على بناء الهيكل القانوني المتين لمنظومة الفرانشايز لديك. نقوم بمراجعة السجل الائتماني والتجاري للممنوحين المحتملين، وإعداد النماذج والشروط التي تضمن التدفق المنتظم لرسوم الامتياز (Royalties)، وتوفير المظلة الحامية لحقوق الملكية الفكرية المتربطة باسمك في السوق.
//             </p>
//           </div>
          
//           {/* Key Advantages Checklist */}
//           <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-6">
//             <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
//               <Network className="w-5 h-5 text-amber-600" /> ركائز نظام الامتياز التجاري:
//             </h3>
            
//             <div className="flex gap-3 items-start">
//               <ShieldCheck className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**شرط الإفصاح الإلزامي:** تقديم وثيقة الإفصاح للممنوح قبل 14 يوماً على الأقل من توقيع العقد نظاماً.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <ShieldCheck className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**استدامة شبكة الفروع:** حوكمة آليات التوريد الحصري والمشتريات لضمان ثبات جودة المنتج النهائي.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <ShieldCheck className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**الحق الوقائي للممنوح:** حماية المستثمر الممنوح من الإنهاء المفاجئ أو عدم التجديد دون سبب جوهري عادل.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Grid Capability Block */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">نطاق الخدمات القانونية للفرانشايز</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">هندسة وحوكمة استثمارات الامتياز لضمان النمو الجغرافي المستدام للعلامات التجارية</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {franchiseOffers.map((offer, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {offer.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{offer.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{offer.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Strict Legal Consequence Disclaimer */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <HelpCircle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">تنبيه نظامي مصيري (المادة 17 من النظام):</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               إذا أخل مانح الامتياز بالتزامات الإفصاح الجوهرية أو لم يقم بقيد العقد رسمياً لدى وزارة التجارة، يحق للممنوح إقامة دعوى قضائية للمطالبة بـ **فسخ عقد الامتياز التجاري مباشرة دون مراجعة الشروط الجزائية، مع إلزام المانح باسترداد كامل الأصول والتعويض عن كافة الخسائر المادية المترتبة.** الاستعانة بمحامٍ متخصص قبل طرح امتيازك هي الخطوة الفاصلة لتأمين استثماراتك.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Action Banner for Conversion Optimization */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <Percent className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل أنت جاهز لمنح أو استقبال امتياز تجاري؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           تواصل مع فريقنا اليوم لمراجعة نموذج عملك، وإعداد وثائق الإفصاح والعقود اللازمة لضمان سلامة توسعك الاستثماري في المملكة.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب صياغة وهيكلة باقة الامتياز التجاري
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }


import { 
  Network, ShieldAlert, Award, FileSpreadsheet, 
  ChevronLeft, Percent, ShieldCheck, FileCheck, 
  HelpCircle, Copy 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function FranchiseServices() {
  
  // Core Franchise and Licensing service modules - Refactored to Navy Light
  const franchiseOffers = [
    {
      title: "صياغة وثيقة الإفصاح وقيدها",
      desc: "إعداد وصياغة وثيقة الإفصاح (Disclosure Document) الشاملة والمطابقة لاشتراطات وزارة التجارة بدقة متناهية، وإتمام إجراءات قيدها رسمياً.",
      icon: <FileSpreadsheet className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "هيكلة وصياغة عقود الامتياز",
      desc: "صياغة وتطوير اتفاقيات الامتياز التجاري (Franchise Agreements) التي تنظم نسب العوائد، النطاق الجغرافي، معايير الجودة، وحقوق التدريب والدعم الفني.",
      icon: <FileCheck className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "حماية العلامة والأسرار التجارية",
      desc: "تأمين وحوكمة الأصول الفكرية الممنوحة، وصياغة أدلة التشغيل القانونية واتفاقيات عدم الإفصاح لحماية الخلطات الوصفية والتقنيات الخاصة بالمانح.",
      icon: <Copy className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "إدارة منازعات الفرانشايز",
      desc: "التمثيل القضائي والتحكيمي في منازعات إنهاء الامتياز غير المشروع، دعاوى المطالبة بالتعويض عن الإخلال بوعود التدريب، وحالات تسريب الأسرار التجارية.",
      icon: <ShieldAlert className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات الامتياز التجاري (الفرانشايز)"
        description="نهيئ لعلامتكم التجارية التوسع الآمن والامتثال الكامل لنظام الامتياز التجاري السعودي"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">صناعة التوسع الآمن ومضاعفة الأثر التجاري</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات الامتياز التجاري (الفرانشايز)</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            سواء كنت مانحاً تسعى للتوسع وبناء شبكة فروع لعلامتك الناجحة، أو ممنوحاً ترغب في استثمار آمن مستند إلى علامة تجارية قائمة؛ نحن نوفر لك الصياغة والحماية القانونية المتكاملة المتوافقة مع نظام الامتياز السعودي.
          </p>
        </div>
      </section>

      {/* Analytical & Growth Framework */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              تحويل نموذج عملك الناجح إلى منظومة قابلة للتكرار القانوني
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              لا يقتصر منح الامتياز التجاري على توقيع عقد بسيط، بل يتطلب تأسيس بيئة امتثال تشريعية تمنع الممنوحين من تشويه سمعة العلامة، وتضمن التزامهم التام بالمعايير التشغيلية الموحدة للمنشأة.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              يعمل مستشارونا على بناء الهيكل القانوني المتين لمنظومة الفرانشايز لديك. نقوم بمراجعة السجل الائتماني والتجاري للممنوحين المحتملين، وإعداد النماذج والشروط التي تضمن التدفق المنتظم لرسوم الامتياز (Royalties)، وتوفير المظلة الحامية لحقوق الملكية الفكرية المتربطة باسمك في السوق.
            </p>
          </div>
          
          {/* Key Advantages Checklist - Refactored to Executive Light Mode */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200/60 space-y-6 shadow-sm">
            <h3 className="text-xl font-bold text-indigo-950 mb-2 flex items-center gap-2">
              <Network className="w-5 h-5 text-blue-700" /> ركائز نظام الامتياز التجاري:
            </h3>
            
            <div className="flex gap-3 items-start">
              <ShieldCheck className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">شرط الإفصاح الإلزامي:</strong> تقديم وثيقة الإفصاح للممنوح قبل 14 يوماً على الأقل من توقيع العقد نظاماً.</p>
            </div>

            <div className="flex gap-3 items-start">
              <ShieldCheck className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">استدامة شبكة الفروع:</strong> حوكمة آليات التوريد الحصري والمشتريات لضمان ثبات جودة المنتج النهائي.</p>
            </div>

            <div className="flex gap-3 items-start">
              <ShieldCheck className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="text-indigo-950">الحق الوقائي للممنوح:</strong> حماية المستثمر الممنوح من الإنهاء المفاجئ أو عدم التجديد دون سبب جوهري عادل.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Grid Capability Block - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">نطاق الخدمات القانونية للفرانشايز</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">هندسة وحوكمة استثمارات الامتياز لضمان النمو الجغرافي المستدام للعلامات التجارية</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {franchiseOffers.map((offer, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {offer.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{offer.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{offer.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Strict Legal Consequence Disclaimer - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <HelpCircle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">تنبيه نظامي مصيري (المادة 17 من النظام):</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              إذا أخل مانح الامتياز بالتزامات الإفصاح الجوهرية أو لم يقم بقيد العقد رسمياً لدى وزارة التجارة، يحق للممنوح إقامة دعوى قضائية للمطالبة بـ <strong className="text-indigo-950">فسخ عقد الامتياز التجاري مباشرة دون مراجعة الشروط الجزائية، مع إلزام المانح باسترداد كامل الأصول والتعويض عن كافة الخسائر المادية المترتبة.</strong> الاستعانة بمحامٍ متخصص قبل طرح امتيازك هي الخطوة الفاصلة لتأمين استثماراتك.
            </p>
          </div>
        </div>
      </section>

      {/* Action Banner for Conversion Optimization - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <Percent className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل أنت جاهز لمنح أو استقبال امتياز تجاري؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          تواصل مع فريقنا اليوم لمراجعة نموذج عملك، وإعداد وثائق الإفصاح والعقود اللازمة لضمان سلامة توسعك الاستثماري في المملكة.
        </p>
        <button className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          طلب صياغة وهيكلة باقة الامتياز التجاري
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}